import React from 'react';
import { Link } from 'react-router-dom';

function Testimonials() {
  return (
    <div className="page-container">
      <h1 className="page-title">Testimonials</h1>
      <blockquote>
        <p>
          Following a flood, I found the process of filing my claim and dealing with my insurance
          company to be extremely stressful, especially given my concerns about not receiving
          sufficient funds for repairs. This was my first time hiring a public insurance adjuster,
          and Cara's performance far exceeded my expectations. Cara's expertise was instrumental in
          ensuring that the process ran smoothly. Thanks to her, we secured the full amount required
          for repairs without enduring prolonged disputes with the insurance company. Her
          professionalism, effectiveness, and the warmth she brought to the process greatly reduced
          my stress and led to a positive outcome. I highly recommend Cara Lawler to anyone in need
          of a public insurance adjuster.
        </p>
        <cite>— Barbara</cite>
      </blockquote>
      <blockquote>
        <p>
          Cara is a professional adjuster. My property had a water damage, the previous construction
          company took more than 6 months dealing with insurance and did a poor job. I was exhausted.
          When Cara took over, she took quick action, submitted new inspection report, dealing with
          insurance company with solid proof, in the end she got me much more money back than previous
          company. During this process, Cara also kept good communication with me, updating progress,
          her estimate etc. I was rest assured most of time. She was quick, meticulous, experienced
          and thinking for her client. I am very happy about her service!
        </p>
        <cite>— Lihua</cite>
      </blockquote>
      <p><Link to="/contact" className="cta-link">Contact</Link></p>
    </div>
  );
}

export default Testimonials;
